module.exports = __webpack_public_path__ + "img/运动小秘详情页_04.25c400dd.jpg";